/**
 * Dismissible banners.
 *
 * Any element with [data-dismissible="<key>"] containing a [data-dismiss] button
 * hides itself when dismissed and stays hidden on later visits.
 *
 * Not a custom element: it applies to the announcement bar, which is above the
 * fold and must not wait on a module import to be dismissable. It is a single
 * delegated listener plus one pass at load.
 *
 * localStorage is wrapped throughout because it throws in Safari private mode
 * and when a browser blocks storage — a banner that cannot remember dismissal is
 * a minor annoyance, but a thrown error that halts the module is not.
 */

const PREFIX = 'theme:dismissed:';

function isDismissed(key) {
  try {
    return window.localStorage.getItem(PREFIX + key) === '1';
  } catch {
    return false;
  }
}

function remember(key) {
  try {
    window.localStorage.setItem(PREFIX + key, '1');
  } catch {
    // Storage unavailable. The banner simply returns next visit.
  }
}

function apply(root) {
  for (const element of root.querySelectorAll?.('[data-dismissible]') ?? []) {
    if (isDismissed(element.dataset.dismissible)) element.hidden = true;
  }
}

apply(document);

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-dismiss]') : null;
  if (!button) return;

  const container = button.closest('[data-dismissible]');
  if (!container) return;

  container.hidden = true;
  remember(container.dataset.dismissible);
});

// Theme editor re-render: honour dismissal on freshly inserted markup.
document.addEventListener('shopify:section:load', (event) => apply(event.target));
